module.exports = __webpack_public_path__ + "static/nutry-346e6d41810210497e050332903a7f37.png";